export const truncateString = (string: string, length: number, ellipsis: string = '...') => {
    if (string.length <= length) {
        return string
    }

    return string.slice(0, Math.max(0, length - ellipsis.length)) + ellipsis
}
